if (!window.alert) {
    window.alert = (...args) => console.log(...args); // tslint:disable-line
}
export const alertOnce = (expression: string, err: Error) => {
    console.error(err); // tslint:disable-line
    const key = `__alerted_casetivity_${expression}`;
    if (!window[key]) {
        const stringifiedErr = JSON.stringify(err);
        window.alert(
            // tslint:disable-line
            `Failed expression "${expression}"
            ${stringifiedErr !== '{}' ? stringifiedErr : 'Please check the console for error details'}
            We have set the result to 'true' by default.
            `,
        );
        window[key] = true;
    }
};
